function state() {
  return {
    levels: [],
    level: {},
  };
}

export default state;
